<ng-template>
  <metric-drawer-tags [formControl]="formControl" [borderless]="borderless" [uiId]="controlId" [metricId]="metricId" [disabled]="disabled"></metric-drawer-tags>
</ng-template>
